<pega-retail
    [actionID]="actionID"
    [assignmentID]="assignmentID"
    [caseID]="caseID"
    [caseTypeID]="caseTypeId"
    [content]="content"
    [initWithSubmit]="initWithSubmit"
    [useState]="useState"
></pega-retail>
